// hooks/auth/useResetPasswordEmailSent.ts
import { useNavigate } from '@tanstack/react-router';

import { useAppDispatch, useAppSelector } from '@/store';
import {
  selectAuthStatus,
  selectForgotPasswordEmailAddress,
} from '@/store/selectors/auth';
import { forgotPasswordThunk } from '@/store/thunks/auth/forgotPasswordThunk';
import { MIN_LEN } from '@/constants';

/**
 * Hook for /reset-password route (email sent confirmation)
 * Handles proceed to OTP verification and resend email
 *
 * @returns Hook state and handlers
 */
export function useResetPasswordEmailSent() {
  const dispatch = useAppDispatch();
  const navigate = useNavigate();

  const authStatus = useAppSelector(selectAuthStatus);
  const emailAddress = useAppSelector(selectForgotPasswordEmailAddress);
  const isLoading = authStatus === 'loading';

  const proceed = async() => {
    await navigate({ to: '/reset-password/otp-verify' });
  };

  const resend = async() => {
    if (typeof emailAddress !== 'string' || emailAddress.trim().length === MIN_LEN) return;
    await dispatch(forgotPasswordThunk({ emailAddress }));
  };

  const backToLogin = async() => {
    await navigate({ to: '/login' });
  };

  return {
    state: { isLoading, emailAddress },
    handlers: { proceed, resend, backToLogin },
  };
}
